import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../store';
import style from '../../../../scss/confirmationDialog.scss';
import close from '../../icons/close';

@customElement('arc-request-dialog')
export class RequestDialog extends connect(store)(LitElement) {
	static styles = [style];
	static properties = {
		open: {type: Boolean},
		title: {type: String},
		message: {type: String},
		labelConfirm: {type: String}
	};

	constructor() {
		super();
		this.open = false;
		this.message = '';
		this.title = '';
		this.labelConfirm = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
	}
	firstUpdated(changedProps) {
		this.dialog = this.renderRoot.querySelector('dialog');
		// listen to external commands
		document.addEventListener('close-request-dialog', this.closeDialog.bind(this));
		// do something when closed
		this.dialog.addEventListener('close', this.handleClose.bind(this));
	}

	openDialog() {
		this.dialog.returnValue = 'cancel';
		this.dialog.showModal();
	}
	closeDialog() {
		this.dialog.close();
	}

	handleOutsideClick(e) {
		if (e.target === this.dialog) this.dialog.close('cancel');
	}
	handleClose(e) {
		// called always when dialog is closed
		// return value contains action
		this.dispatchEvent(new CustomEvent(this.dialog.returnValue, {bubbles: true, composed: true}));
	}


	render() {
		return html`
			<dialog class="dialog" @click=${this.handleOutsideClick}>
				<div class="modal-content">
					<h2 class="dialogTitle">${this.title}</h2>
					<p class="dialogMessage">${this.message}</p>
					<div class="dialogContent">
						<slot></slot>
					</div>
					<div class="dialogButtons">
						<arc-button
							@click=${() => this.dialog.close('cancel')}
							type="secondary"
							title="${this.labelCancel ?? 'Cancel'}"
						></arc-button>
						<arc-button
							@click=${() => this.dialog.close('confirm')}
							type="primary"
							title="${this.labelConfirm ?? 'OK'}"
						></arc-button>
					</div>
					<button class="closeIcon" @click=${() => this.dialog.close('cancel')} aria-label="${msg('Close')}">
						${close}
					</button>
				</div>
			</dialog>
		`;
	}
}
